import Vue from 'vue'
import Router from 'vue-router'
import Users from '../pages/Users'
import Roles from '../pages/Roles'
import Permissions from '../pages/Permissions'
import Abogados from '../pages/Abogados'
import HomeTraslado from '../pages/traslados/home'
import LoginPersona from '../pages/traslados/persona/login'
import ResetPersona from '../pages/traslados/persona/reset'
import HomeTrasladoPersona from '../pages/traslados/persona/home'
import FormularioTrasladoPersona from '../pages/traslados/persona/formulario'

import LoginRepresentante from '../pages/traslados/representante/login'
import ResetRepresentante from '../pages/traslados/representante/reset'
import HomeTrasladoRepresentante from '../pages/traslados/representante/home'
import AbogadosConfianza from '../pages/AbogadosConfianza'
import AtencionVictimas from '../pages/AtencionVictimas'
import AtencionVictimasRegistro from '../pages/AtencionVictimasRegistro'
import ListadoPersonas from '../pages/traslados/persona/personas'
import Bloques from '../pages/traslados/bloques'
import GestionPersonas from '../pages/traslados/gestion/personas'
import GestionRepresentantes from '../pages/traslados/gestion/representantes'

// import FormularioTrasladoRepresentante from '../pages/traslados/traslado/formulario'
// import Respuestas from '../pages/traslados/respuestas'

Vue.use(Router)

export default new Router({
	mode: 'history',
	props: ['url_action'],
	routes: [
		{
			path: '/home',
			redirect: { path: '/home/atencion_victimas' }
		},
		{
			path: '/home/users',
			component: Users
		},
		{
			path: '/home/roles',
			component: Roles
		},
		{
			path: '/home/permissions',
			component: Permissions
		},
		{
			path: '/home/abogados',
			component: Abogados
		},
		{
			path: '/home/abogados_confianza',
			component: AbogadosConfianza
		},
		{
			path: '/home/traslado/personas/formulario',
			name: 'listado-gestion-personas',
			component: GestionPersonas
		},
		{
			path: '/home/traslado/representantes/formulario',
			name: 'listado-gestion-representantes',
			component: GestionRepresentantes
		},
		{
			path: '/traslado',
			component: HomeTraslado
		},
		{
			name: 'traslado-personas',
			path: '/traslado/personas',
			component: LoginPersona
		},
		{
			name: 'traslado-personas-login-reset',
			path: '/traslado/personas/token/:token',
			props: true,
			component: ResetPersona
		},
		{
			name: 'traslado-personas-home',
			path: '/traslado/personas/home',
			component: HomeTrasladoPersona
		},
		{
			name: 'traslado-personas-formulario',
			path: '/traslado/personas/formulario/:tipo/:persona_id',
			props: true,
			component: FormularioTrasladoPersona
		},
		{
			name: 'traslado-representantes',
			path: '/traslado/representantes',
			component: LoginRepresentante
		},
		{
			name: 'traslado-representantes-login-reset',
			path: '/traslado/representantes/token/:token',
			props: true,
			component: ResetRepresentante
		},
		{
			path: '/traslado/representantes/home',
			component: HomeTrasladoRepresentante
		},
		// {
		// 	name: 'traslado-representantes-formulario',
		// 	path: '/traslado/representantes/formulario/:tipo/:persona_id',
		// 	props: true,
		// 	component: FormularioTrasladoRepresentante
		// },
		{
			path: '/publico/atencion_victimas',
			component: AtencionVictimasRegistro
		},
		{
			path: '/home/atencion_victimas',
			component: AtencionVictimas
		},
		{
			path: '/traslado/bloques/:persona',
			name: 'bloques',
			component: Bloques
		},
		// {
		// 	path: '/traslado/respuestas/:persona',
		// 	name: 'respuestas',
		// 	component: Respuestas
		// },
		{
			path: '/traslado/representantes/personas',
			name: 'listado-personas',
			component: ListadoPersonas
		},
	]
})
